import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Address } from 'src/app/domain/address';
import { City } from 'src/app/domain/city';
import { Covenant } from 'src/app/domain/covenant';
import { State } from 'src/app/domain/state';
import { ViaCep } from 'src/app/domain/viacep';
import { AddressService } from 'src/app/service/address/address.service';
import { CovenantService } from 'src/app/service/covenant/covenant.service';
import { UtilsService } from 'src/app/service/utils/utils.service';
import Swal from 'sweetalert2';
import { Validations } from '../../validations';

import { LyDialog } from '@alyle/ui/dialog';
import { ImgCropperEvent } from '@alyle/ui/image-cropper';
import { CropperDialog } from '../../cropper/cropper-dialog';
import { TimeoutError } from 'rxjs';

@Component({
  selector: 'app-covenant-create',
  templateUrl: './covenant-create.component.html',
  styleUrls: ['./covenant-create.component.scss'],
})
export class CovenantCreateComponent implements OnInit {
  covenantForm: FormGroup;
  loading: boolean = false;
  messageError: string = '';
  viacep: ViaCep = new ViaCep();
  states: Array<State> = [];
  cities: Array<City> = [];
  covenantPaymentMethods;

  image: File;
  cropped?: string;

  constructor(
    private service: CovenantService,
    private serviceAddress: AddressService,
    private utilsService: UtilsService,
    private fb: FormBuilder,
    private router: Router,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.getPaymentMethods();
    this.serviceAddress.getStates().subscribe(
      (data) => {
        this.states = data;
      },
      (error) => {
        Swal.fire('Erro', 'Não foi possível Buscar os Estados!', 'error');
      }
    );
  }

  getPaymentMethods() {
    this.loading = true;
    this.service.getPaymentMethods().subscribe(
      (data) => {
        this.covenantPaymentMethods = data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.openPaymentAlertError();
      }
    );
  }

  openPaymentAlertError() {
    Swal.fire(
      'Ops...',
      'Ocorreu um erro ao carregar as formas de pagamento!',
      'error'
    );
  }

  createForm() {
    this.covenantForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(60)]],
      cpfCnpj: ['', [Validators.required, Validators.maxLength(18)]],
      email: ['', [Validators.maxLength(80), Validators.email]],
      emailContact: ['', [Validators.maxLength(80), Validators.email]],
      stateRegistration: ['', [Validators.maxLength(30)]],
      municipalRegistration: ['', [Validators.maxLength(30)]],
      paymentMethods: ['', Validators.required],
      phone: ['', [Validators.required, Validations.validPhone]],
      whatsapp: ['', [Validations.validwhatsapp]],
      contact: ['', [Validators.maxLength(100), Validators.required]],
      zipCode: ['', [Validators.required, Validators.maxLength(9)]],
      publicPlace: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: [null, [Validators.required]],
      invoice: ['', [Validators.required]],
      shareRun: ['', [Validators.required]],
      imageUrl: [''],
    });
  }
  onBlurCep(event) {
    // event.target.value
    this.loading = true;

    if (event.target.value.replace(/[^0-9,.]+/g, '').length === 8) {
      this.utilsService
        .getCep(event.target.value.replace(/[^0-9,.]+/g, ''))
        .subscribe(
          (data) => {
            this.viacep = data;

            if (!this.viacep.erro) {
              this.covenantForm.controls.neighborhood.setValue(
                this.viacep.bairro
              );
              this.covenantForm.controls.publicPlace.setValue(
                this.viacep.logradouro
              );
              const state = this.states.find(
                (state) => state.initials === this.viacep.uf.toUpperCase()
              );

              this.covenantForm.controls.state.setValue(state.id);

              // TODO - Implementar busca de cidades por UF
              this.serviceAddress.getCitiesByStateId(state.id).subscribe(
                (data) => {
                  this.cities = data;
                  const city = this.cities.find(
                    (elem) =>
                      elem.name.normalize('NFD') ===
                      this.viacep.localidade
                        .toUpperCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                  );
                  if (city) {
                    this.covenantForm.controls.city.setValue(city.id);
                  }
                },
                (error) => {
                  Swal.fire(
                    'Erro ao salvar',
                    'Erro ao buscar cidades!',
                    'error'
                  );
                }
              );
            } else {
              this.covenantForm.controls.zipCode.setErrors({
                invalid: 'CEP não encontrado!',
              });
            }
            this.loading = false;
          },
          (err) => {
            if (err instanceof TimeoutError) {
              Swal.fire({
                title: 'Erro ao buscar os dados do endereço!',
                text: 'O Servidor de busca de endereços não respondeu!\nPor favor, preencha os dados de endereço manualmente.',
                icon: 'error',
                toast: false,
              });
              this.loading = false;
              return;
            }
            this.covenantForm.controls.zipCode.setErrors({
              invalid: 'CEP não encontrado!',
            });
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
      this.covenantForm.controls.zipCode.setErrors({
        invalid: 'CEP inválido!',
      });
    }
  }

  onSelectedState(event) {
    // TODO - Ao selecionar um estado no formulário de busca ir no servidor e buscar as cidades relacionadas ao estado
    if (event.target.value) {
      this.loading = true;
      this.serviceAddress.getCitiesByStateId(event.target.value).subscribe(
        (data) => {
          this.cities = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          Swal.fire('Ops', 'Erro ao buscar cidades!', 'error');
        }
      );
    }
  }

  onSelectedPaymentValue(event) {}

  onRemoveImage(event) {
    this.cropped = '';
    this.image = null;
    this.covenantForm.controls.imageUrl.reset('');
  }

  onSelectImage(file) {
    if (file.size > 10000000) {
      this.image = null;
      Swal.fire('Ops...', 'A imagem não pode ser maior que 10MB!', 'error');
      return false;
    } else {
      this.image = file;
      this.onFileReader();
      return true;
    }
  }

  onFileReader() {
    const reader = new FileReader();
    reader.readAsDataURL(this.image);
    reader.onload = () =>
      this.covenantForm.controls.imageUrl.setValue(reader.result);
  }

  onSubmit() {
    let covenant = new Covenant();
    covenant.address = new Address();
    covenant.address.city = new City();
    covenant.name = this.covenantForm.controls.name.value;
    covenant.cpfCnpj = this.covenantForm.controls.cpfCnpj.value;
    covenant.municipalRegistration =
      this.covenantForm.controls.municipalRegistration.value;
    covenant.stateRegistration =
      this.covenantForm.controls.stateRegistration.value;
    covenant.email = this.covenantForm.controls.email.value;
    covenant.emailContact = this.covenantForm.controls.emailContact.value;
    covenant.phone = this.covenantForm.controls.phone.value;
    covenant.whatsapp = this.covenantForm.controls.whatsapp.value;
    covenant.contact = this.covenantForm.controls.contact.value;
    covenant.address.zipCode = this.covenantForm.controls.zipCode.value.replace(
      /[^0-9,.]+/g,
      ''
    );
    covenant.address.neighborhood =
      this.covenantForm.controls.neighborhood.value;
    covenant.address.publicPlace = this.covenantForm.controls.publicPlace.value;
    covenant.address.city.id = Number(this.covenantForm.controls.city.value);
    covenant.shareRun = Number(this.covenantForm.controls.shareRun.value);
    covenant.invoice = this.covenantForm.controls.invoice.value;
    covenant.covenantPaymentMethods = [];

    if (this.covenantForm.controls.paymentMethods.value) {
      this.covenantForm.controls.paymentMethods.value.forEach((method) => {
        covenant.covenantPaymentMethods.push({ id: method, name: null });
      });
    }

    this.loading = true;
    this.service.save(covenant).subscribe(
      (data) => {
        if (this.image) {
          this.service
            .imageUpload(data.body['id'], this.image)
            .subscribe((data) => {
              this.loading = false;
              this.showSuccess();
            }),
            (error) => {
              this.loading = false;
              Swal.fire(
                'Erro ao salvar imagem',
                'Convênio salvo, mas não foi possível salvar a imagem!',
                'error'
              );
            };
        } else {
          this.loading = false;
          this.showSuccess();
        }
        this.createForm();
      },
      (error) => {
        this.loading = false;
        this.setErrors(error.error.errors);
        Swal.fire(
          'Erro ao salvar',
          'Não foi possível salvar Convênio!',
          'error'
        );
      }
    );
  }

  showSuccess() {
    Swal.fire('Salvo', 'Convênio salvo com sucesso!!', 'success').then(
      (result) => {
        if (result.value) {
          this.router.navigate(['maintenance/covenant']);
        }
      }
    );
  }

  resetForm() {
    this.covenantForm.controls.name.setValue('');
    this.covenantForm.controls.cpfCnpj.setValue('');
    this.covenantForm.controls.municipalRegistration.setValue('');
    this.covenantForm.controls.stateRegistration.setValue('');
    this.covenantForm.controls.email.setValue('');
    this.covenantForm.controls.emailContact.setValue('');
    this.covenantForm.controls.phone.setValue('');
    this.covenantForm.controls.whatsapp.setValue('');
    this.covenantForm.controls.contact.setValue('');
    this.covenantForm.controls.zipCode.setValue('');
    this.covenantForm.controls.neighborhood.setValue('');
    this.covenantForm.controls.publicPlace.setValue('');
    this.covenantForm.controls.state.setValue('');
    this.covenantForm.controls.city.setValue('');
  }

  setErrors(errors) {
    errors.forEach((erro) => {
      switch (erro.fieldName) {
        case 'name':
          this.covenantForm.controls.name.setErrors({ invalid: erro.message });
          break;
        case 'cpfCnpj':
          this.covenantForm.controls.cpfCnpj.setErrors({
            invalid: erro.message,
          });
          break;
        case 'municipalRegistration':
          this.covenantForm.controls.municipalRegistration.setErrors({
            invalid: erro.message,
          });
          break;
        case 'stateRegistration':
          this.covenantForm.controls.stateRegistration.setErrors({
            invalid: erro.message,
          });
          break;
        case 'email':
          this.covenantForm.controls.email.setErrors({ invalid: erro.message });
          break;
        case 'emailContact':
          this.covenantForm.controls.emailContact.setErrors({
            invalid: erro.message,
          });
          break;
        case 'phone':
          this.covenantForm.controls.phone.setErrors({ invalid: erro.message });
          break;
        case 'whatsapp':
          this.covenantForm.controls.email.setErrors({ invalid: erro.message });
          break;
        case 'contact':
          this.covenantForm.controls.contact.setErrors({
            invalid: erro.message,
          });
          break;
        case 'zipCode':
          this.covenantForm.controls.zipCode.setErrors({
            invalid: erro.message,
          });
          break;
        case 'neighborhood':
          this.covenantForm.controls.neighborhood.setErrors({
            invalid: erro.message,
          });
          break;
        case 'publicPlace':
          this.covenantForm.controls.publicPlace.setErrors({
            invalid: erro.message,
          });
          break;
        case 'state':
          this.covenantForm.controls.state.setErrors({ invalid: erro.message });
          break;
        case 'city':
          this.covenantForm.controls.city.setErrors({ invalid: erro.message });
          break;
        case 'invoice':
          this.covenantForm.controls.invoice.setErrors({
            invalid: erro.message,
          });
          break;
        case 'shareRun':
          this.covenantForm.controls.shareRun.setErrors({
            invalid: erro.message,
          });
          break;
        default:
          this.messageError += `${erro.message}\n`;
      }
    });
  }

  openCropperDialog(event) {
    const imgFile = event.target.files['0'];
    let selImg = this.onSelectImage(imgFile);

    if (selImg) {
      this.cropped = null!;
      this._dialog
        .open<CropperDialog, Event>(CropperDialog, {
          data: event,
          width: 320,
          disableClose: true,
        })
        .afterClosed.subscribe((result?: ImgCropperEvent) => {
          if (result) {
            this.cropped = result.dataURL;
            this._cd.markForCheck();
          }
        });
    }
  }
}
